import { render, staticRenderFns } from "./MailTemplateListTop.vue?vue&type=template&id=193570d5&scoped=true&"
import script from "./MailTemplateListTop.vue?vue&type=script&lang=js&"
export * from "./MailTemplateListTop.vue?vue&type=script&lang=js&"
import style0 from "./MailTemplateListTop.vue?vue&type=style&index=0&id=193570d5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "193570d5",
  null
  
)

export default component.exports